// removed by extract-text-webpack-plugin
module.exports = {"carousel":"YoOZk","arrow":"_114rk","carouselImage":"_2RzJM","arrowLeft":"NRsbS","arrowRight":"_2xUK-"};